export default __webpack_public_path__ + "static/IN-8015_8mm_lense_day_zoom-419f867a8611349943993b8063a513fb.webp";